import { translateFilterOptionLabel } from "./translate-utils";

export const PRIORITY_LEVELS = {
	VERY_URGENT: "VERY_URGENT",
	URGENT: "URGENT",
	NORMAL: "NORMAL",
	LOW: "LOW",
};

export const getPriorityConfig = (priority) => {
	if (priority === PRIORITY_LEVELS.VERY_URGENT) {
		return {
			color: "error",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.VERY_URGENT,
			style: {
				backgroundColor: "rgba(248, 224, 224, 1)",
				color: "var(--red-500)",
				fontWeight: 600,
				border: "none",
			},
		};
	}
	if (priority === PRIORITY_LEVELS.URGENT) {
		return {
			color: "warning",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.URGENT,
			style: {
				backgroundColor: "rgba(253, 243, 225, 1)",
				color: "var(--amber-500)",
				fontWeight: 600,
				border: "none",
			},
		};
	}
	if (priority === PRIORITY_LEVELS.NORMAL) {
		return {
			color: "success",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.NORMAL,
			style: {
				backgroundColor: "rgba(237, 246, 227, 1)",
				color: "var(--lime-500)",
				fontWeight: 600,
				border: "none",
			},
		};
	}
	if (priority === PRIORITY_LEVELS.LOW) {
		return {
			color: "default",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.LOW,
			style: {
				backgroundColor: "var(--grey-100)",
				color: "var(--grey-400)",
				fontWeight: 600,
				border: "none",
			},
		};
	}
	return {
		color: "default",
		label: priority || "-",
		level: PRIORITY_LEVELS.LOW,
		style: {
			backgroundColor: "var(--grey-100)",
			color: "var(--grey-400)",
			fontWeight: 600,
			border: "none",
		},
	};
};
